import MoneyTokenizer from './MoneyTokenizer';
import { TokenFormat } from './types';

const PartsFormatter = (formatter) => ({
  format(amount) {
    const parts = formatter.formatToParts(amount);
    const tokenizer = MoneyTokenizer(parts);
    const moneyParts: TokenFormat[] = [];
    let token = tokenizer.getToken();
    while (token) {
      moneyParts.push(token);
      token = tokenizer.getToken();
    }
    return moneyParts;
  },
});

export default PartsFormatter;
